import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PassengerUpdateResponse } from '@shared/services/passenger-change/_interfaces_/passenger-change.interface';
import { PaxChangeService } from '@shared/services/passenger-change/passenger-change.service';

@Injectable({ providedIn: 'root' })
export class PassengerUpdateResolver implements Resolve<PassengerUpdateResponse | null> {
  constructor(private paxChangeService: PaxChangeService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<PassengerUpdateResponse | null> {
    const updateDataFromState = history.state?.updateData as PassengerUpdateResponse | null;
    if (updateDataFromState) {
      return of(updateDataFromState);
    }

    return this.paxChangeService.getLastPassengerUpdateResponse(); 
  }
}
